import { defineStyleConfig, defineStyle } from '@chakra-ui/react';

const main = defineStyle({
  backgroundColor: 'rentals.primary.btn',
  color: 'white',
  _hover: {
    backgroundColor: 'transparent',
    color: 'rentals.primary.btn',
    borderWidth: '1px',
    borderColor: 'rentals.primary.btn',
    _disabled: {
      backgroundColor: '#9F9DB0',
    },
  },
  _focusVisible: {
    backgroundColor: 'rentals.primary.btn',
    borderWidth: '1px',
    borderColor: 'rentals.primary.btn',
  },
  _disabled: { backgroundColor: '#9F9DB0' },
});

const Button = defineStyleConfig({
  variants: { main },
  defaultProps: { variant: 'main' },
});

export default Button;
